import React, { useEffect, useState } from "react";
import tick from "../../Assets/svg/green-tick.svg";
import "./submission.scss";
import Button from "../modules/Button";
import ModalComponent from "../modules/Modal";
import RatingSize from "../modules/Stars";
import Input from "../modules/Input";
import TransitionAlerts from "../modules/Alerts";
import {useDispatch, useSelector } from "react-redux";
import { GetBaseUrl } from "../modules/getBaseUrl";
import FooterText from "../modules/FooterText";
import { api } from "../../Services";
import GradientLoader from "../modules/Loader";
import { ToastContainer, toast } from "react-toastify";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";
function Submission() {
  const dispatch = useDispatch();

  const [alert, setAlert] = useState(true);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [feedback, setFeedback] = useState({
    stars: 0,
    options: [],
    comment: "",
  });
  const [loading, setLoading] = useState(false);

  const [btnList, setBtnList] = useState([
    { title: "Design", selected: false },
    { title: "Convenience", selected: false },
    { title: "Process", selected: false },
    { title: "Flexibility", selected: false },
    { title: "Ease of Use", selected: false },
    { title: "Other", selected: false },
  ]);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "cancel",
    title: "So...How was it?",
    countDown: " ",
    desc: "We would love to know more about your experience regarding the application process :)",
  });
  const setSelect = (index) => {
    let list = { ...feedback };
    list["options"] = [...list["options"], btnList[index].title];
    setFeedback({ ...list });
  };

  const notify = (item) => {
    toast(item);
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const sendFed = async () => {
    try {
      setLoading(true);
      let data = {
        feedbackPertainsTo: [...feedback.options],
        rate: feedback.stars,
        comment: feedback.comment,
        parentApplicationId: idInfo.appId,
      };

      const send = await api.feedback(data, idInfo.token);
      if (send.statusCode !== 200 && send.data.includes("Session expired")) {
        logoutMsg();
      }
      console.log("query", send);
      return send;
    } catch (err) {

      if (err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  const fedSubmit = async () => {
    try {
      let result = await sendFed();
      if (result.statusCode == 200) {
        setLoading(false);
        setModalData({ ...ModalData, show: false });
        setAlert(true);
        notify("Feedback submitted successfully.");

        setTimeout(() => setAlert(false), 3000);
      }
    } catch (err) {
      setLoading(false);
      // notify("Sorry! Something went wrong,Please try again.");
      // alert('Sorry! Something went wrong,Please try again.');
    }
  };
  const feedbackContent = () => {
    return (
      <div className="feedback-content">
        <div className="stars sub-option-text">
          How was your overall experience?
          <RatingSize
            value={feedback.stars}
            onChange={(e) => setFeedbackData("stars", e)}
          />
        </div>
        {feedback.stars > 0 && (
          <div className="multi-btns">
            <div className="sub-option-text">
              What does this feedback pertain to?
              <div className="buttons-set">
                {btnList.map((item, index) => (
                  <div
                    onClick={() => setSelect(index)}
                    className={` sub-option-text ${
                      feedback.options.includes(item?.title)
                        ? "contained"
                        : "btn-option"
                    }`}
                  >
                    {item?.title}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {feedback?.options?.length > 0 && (
          <div className="comment-field">
            <Input
              onChange={(e) =>
                setFeedbackData("comment", e.replace(/[^a-zA-Z0-9. ]/g, ""))
              }
              placeholder={"Could you tell us a little more?"}
              multiline={true}
            />
          </div>
        )}
        <div className="cred-btn">
          <Button
            onClickHandler={() => fedSubmit()}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Submit"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll do this later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };
  const backToHome = () => {
    let url = GetBaseUrl(window.location.href);
    window.location.replace(url + "/application/submitted-status");
  };

  const setFeedbackData = (type, e) => {
    let fed = feedback;
    fed[type] = e;
    console.log("fed", fed);
    setFeedback({ ...fed });
  };

  const toHelp = () => {
    let url = GetBaseUrl(window.location.href);
    window.location.replace(url + "/application/help");
  };
  useEffect(() => {
    if (!ModalData.show) {
      console.log("on close");
    }
  }, [ModalData.show]);
  useEffect(() => {
    setTimeout(() => setModalData({ ...ModalData, show: true }), 3000);
    setTimeout(() => setAlert(false), 3000);
  }, []);
  return (
    <>
      <div className="form-div review submission">
        <div className="review-heading">
          <div className="form-title">
            <img src={tick} alt="tick" />
            Application Submitted Successfully!
          </div>
        </div>
        <div className="info-text">
          <div className="option-text">
            Your application ID is{" "}
            <span className="highlight">
              {idInfo.applicationData.salesforceStudentAppNumber}
            </span>
          </div>
          <div className="option-text">
            You should receive an email on the status of your application, as
            per progress.
          </div>
          <div className="option-text">
            The email will also have instructions on the next steps to complete
            the process, if any.
          </div>
          <div className="option-text">
            {/* In the meantime,{" "} */}
            <div>
              In case of any query, please reach us via
              <span className="highlight underline" onClick={() => toHelp()}>
                Help Page
              </span>
            </div>
          </div>
        </div>
        <Button
          type={"contained"}
          value={"Back to Home"}
          onClickHandler={() => backToHome()}
        />
        {ModalData.show && (
          <ModalComponent
            show={ModalData.show}
            handleClose={() => setModalData({ ...ModalData, show: false })}
            title={ModalData.title}
            content={ModalData.desc}
            className={"feedback"}
            // countDown={ModalData.countDown}
          >
            {feedbackContent()}
          </ModalComponent>
        )}
        <FooterText />
      </div>
      <TransitionAlerts
        isAlert={alert}
        message={"Your documents uploded successfully!"}
      />
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </>
  );
}

export default Submission;
